import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper/modules';
import { useGetMilestoneRewards } from '@/query/queries/streak/useGetMilestoneRewards';
import { useWindowSize } from '@/hooks/useWindowSize';
import { STREAK_STEP } from '@/helpers/constants';
import { MilestoneCard } from './card';
import { SliderNavigation } from './navigation';
import s from './index.module.scss';

export const MilestoneRewards = ({ status }) => {
  const [swiperRef, setSwiperRef] = useState(null);
  const { isMobile } = useWindowSize();
  const { t } = useTranslation('streak');
  const [params, setParams] = useState({
    isBeginning: true,
    isEnd: false,
  });

  const { data: rewards } = useGetMilestoneRewards();

  const onNext = () => {
    swiperRef?.slideNext();
  };

  const onPrev = () => {
    swiperRef?.slidePrev();
  };

  useEffect(() => {
    if (rewards && status && swiperRef) {
      const currentRewardSlideIndex = parseInt(status.streak / STREAK_STEP);
      const index =
        currentRewardSlideIndex > rewards.length - 1
          ? rewards.length - 1
          : currentRewardSlideIndex;
      swiperRef?.slideTo(index);
    }
  }, [rewards, status, swiperRef]);

  if (!rewards) return null;

  return (
    <div className={s.wrapper}>
      <div className="f-hero-h5">{t('milestone_rewards.title')}</div>
      <div className={s.slider_container}>
        <div className={s.inner}>
          <Swiper
            onSwiper={setSwiperRef}
            onSlideChange={() => {
              setParams({
                isBeginning: swiperRef.isBeginning,
                isEnd:
                  swiperRef.isEnd ||
                  swiperRef.snapIndex - swiperRef.activeIndex === 1,
              });
            }}
            className={s.slider}
            modules={[Navigation, Pagination]}
            slidesPerView={isMobile ? 1.1 : 3}
            spaceBetween={12}
          >
            {rewards.map((reward, index) => (
              <SwiperSlide key={index} style={{ width: '335px' }}>
                <MilestoneCard
                  key={reward.milestone}
                  currentStreak={status.streak}
                  reward={reward}
                />
              </SwiperSlide>
            ))}
          </Swiper>
          <SliderNavigation onNext={onNext} onPrev={onPrev} params={params} />
        </div>
      </div>
    </div>
  );
};
